import React, { useEffect, useMemo, useState } from 'react'
import './index.less'
import { Button, Checkbox, Col, Divider, Form, Input, InputNumber, Modal, Row, Select, Space, Typography } from 'antd'
import RowHeader from '../RowHeader'
import { CloseCircleFilled, CloseCircleTwoTone, PlusCircleOutlined, QuestionCircleOutlined } from '@ant-design/icons'
import Flex from '../Flex'
import imagesvg from '../../assets/images/toolsImg/1.png'
import config from '@/config'

type ExperEnvProps = {
    labCode: string                 // 去升级需要的数据
    disabledUpdate?: boolean        // 是否禁用去升级
    selectEnv?: () => void          // 选择环境
    experEnvList?: any[]            // 实验环境列表
    updatePort?: (type: 'update' | 'add', ports: any, value?: any) => void// 更新端口
}

const ExperEnv: React.FC<ExperEnvProps> = (props) => {

    const { selectEnv, experEnvList, updatePort, labCode, disabledUpdate = false } = props

    const [showExplain, setShowExplain] = useState(false)

    const form = Form.useFormInstance()
    const experEnv = Form.useWatch('experEnv', form)
    const expertools = Form.useWatch('expertools', form)
    const ports = Form.useWatch('ports', form)

    // 当前实验容器
    const experTools = useMemo(() => {
        const env = experEnvList?.find((item: any) => item.location === experEnv)
        return env?.containers ?? []
    }, [experEnvList, experEnv])

    // 用户自定义的端口数量
    const portCreatorNum = useMemo(() => {
        return ports?.filter((item: any) => item?.type === 'creator')?.length || 0
    }, [ports])

    // 合并端口工具
    const mergePorts = (data: any, target: any) => {
        data = data?.map((item: any) => ({ ...item, choice: true, type: item?.type ? item?.type : 'system' })) ?? []
        const res = target?.filter((item: any) => item?.type === 'creator')?.filter((item: any) => !data?.some((it: any) => it.port === item?.port))
        return data.concat(res)
    }


    return (
        <div className='ExperEnv'>
            <RowHeader title='实验环境' style={{ marginBottom: '16px' }} />
            <Form.Item >
                <Row gutter={10}>
                    <Col flex='auto' className='ExperEnv-select-disabled'>
                        <Form.Item
                            name="experEnv"
                            noStyle
                        >
                            <Select
                                disabled
                                placeholder='请选择环境'
                                fieldNames={{ label: 'name', value: 'location' }}
                                options={experEnvList}
                                onChange={(value) => {
                                    const env = experEnvList?.find((item: any) => item.location === value)
                                    form.setFieldValue('name', env?.name)
                                    form.setFieldValue('expertools', env?.containers[0]?.name)
                                    const resPorts = mergePorts(env?.containers[0]?.ports ?? [], ports ?? [])
                                    form.setFieldValue('ports', resPorts)
                                }}
                            />
                        </Form.Item>
                        <Form.Item name='name' hidden></Form.Item>
                        <div className='ExperEnv-select-disabled-innert' onClick={selectEnv} data-has={!!experEnv}>
                            <CloseCircleFilled className='ExperEnv-select-disabled-innert-clear' style={{ color: 'rgba(0, 0, 0, 0.25)', width: '12px' }} onClick={(e) => {
                                e.stopPropagation()
                                form.setFieldValue('experEnv', undefined)
                            }} />
                        </div>
                    </Col>
                    <Col flex='none'>
                        <Button type='primary' onClick={selectEnv}>选择环境</Button>
                    </Col>
                </Row>
            </Form.Item>

            {
                experEnv ? <>
                    <RowHeader title='端口管理' style={{ marginBottom: '16px' }} />
                    <Form.Item
                        label='环境容器'
                        name='expertools'
                        rules={[
                            { required: true, message: '请选择环境容器', validateTrigger: "onSubmit", whitespace: true },
                        ]}
                        validateFirst
                    >
                        <Select
                            options={experTools}
                            fieldNames={{ label: 'name', value: 'name' }}
                            onChange={(value) => {
                                const containers = experTools?.find((item: any) => value === item?.name)
                                const resPorts = mergePorts(containers?.ports ?? [], ports ?? [])
                                form.setFieldValue('ports', resPorts)
                            }}
                        />
                    </Form.Item>
                    <Form.Item
                        label='访问端口'
                        required
                    >
                        <Form.List name="ports" >
                            {
                                (fields, { add, remove }, { errors }) => {
                                    return <>
                                        {
                                            !!fields?.length && <Flex vertical gap={16} style={{ border: '1px solid #d9d9d9', borderRadius: '6px', marginBottom: '12px', padding: '16px 10px' }}>
                                                {
                                                    fields.map(({ key, name, ...field }, index) => {
                                                        const portData = form.getFieldValue(['ports', name])
                                                        return <Row key={key} gutter={8}>
                                                            <Col flex='0 1 0'>
                                                                <img src={portData?.image || imagesvg} style={{ width: 16, height: 16, marginTop: 3 }} alt="" />
                                                            </Col>
                                                            <Col flex='1 0 0' className='os-ellipsis'>
                                                                {portData?.name}
                                                            </Col>
                                                            <Col flex='0 1 auto'>
                                                                <Typography.Link disabled={portData?.type !== 'creator'} onClick={() => { updatePort?.('update', ports, portData) }}>编辑</Typography.Link>
                                                            </Col>
                                                            <Col flex='0 1 auto'>
                                                                <Typography.Link disabled={portData?.type !== 'creator'} onClick={() => { remove(name) }}>删除</Typography.Link>
                                                            </Col>
                                                            <Col flex='0 1 0'>
                                                                <Divider type="vertical" />
                                                            </Col>
                                                            <Col flex='0 1 0'>
                                                                <Form.Item
                                                                    {...field}
                                                                    noStyle
                                                                    valuePropName="checked"
                                                                    name={[name, 'choice']}
                                                                >
                                                                    <Checkbox />
                                                                </Form.Item>
                                                            </Col>
                                                        </Row>
                                                    })
                                                }
                                            </Flex>
                                        }
                                        <Typography.Link disabled={portCreatorNum >= 10} onClick={() => {
                                            if (portCreatorNum < 10) {
                                                updatePort?.('add', ports)
                                            }
                                        }}><Space size={4}><PlusCircleOutlined />添加端口</Space></Typography.Link>
                                    </>
                                }
                            }
                        </Form.List>
                    </Form.Item>

                    <RowHeader title='环境管控' style={{ marginBottom: '16px' }} />
                    <Form.Item noStyle>
                        <Space size={10}>
                            <Form.Item
                                label='环境使用时长'
                                name='duration'
                                rules={[
                                    { required: true, message: '请设置环境使用时长', validateTrigger: "onSubmit", whitespace: true, type: 'number' },
                                ]}
                                extra={<div style={{ width: 20, position: 'relative', height: 24, marginTop: 4 }}>
                                    <div style={{ position: 'absolute', whiteSpace: 'nowrap' }}>
                                        基础版最长使用时长为45分钟，若需更多使用时长可升级版本<Typography.Link disabled={disabledUpdate} style={{ marginLeft: 4 }} onClick={() => {
                                            const url = `${config.osApiURL}/membership?labCode=${labCode}`
                                            window.open(url)
                                        }}>去升级</Typography.Link>
                                    </div>
                                </div>}
                                validateFirst
                            >
                                <InputNumber style={{ width: 140 }} addonAfter='分钟' min={15} max={180} precision={0} />
                            </Form.Item>
                            <QuestionCircleOutlined onClick={() => { setShowExplain(true) }} style={{ marginBottom: '46px' }} className='svgHover' />
                        </Space>
                    </Form.Item>
                </> : <></>
            }

            <Modal
                open={showExplain}
                wrapClassName={'ylzcc-modal-env-time-help'}
                onCancel={() => { setShowExplain(false) }}
                footer={false}
                centered={true}
                width={400}
                destroyOnClose={true}
            >
                <div className='explain'>
                    <p><span>1.&nbsp;</span><span>环境使用时长为当前环境单次学习最大可使用时长。</span></p>
                    <p><span>2.&nbsp;</span><span>环境使用时长到达时，该环境将会被关闭。</span></p>
                </div>
            </Modal>
        </div>
    )
}

export default ExperEnv